var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 230.637,
    height: 190.726,
    viewBox: "0 0 230.637 190.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14555",
    "data-name": "Group 14555",
    transform: "translate(-393.355 -253.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31483",
    "data-name": "Path 31483",
    d: "M341.517,462.177c-10.836,4.532-22.847,7.463-34.549,4.867-14.244-3.16-23.126-14.638-34.732-22.4-27.648-18.488-47.645,10.68-73.651,15.7-24.609,4.751-43.793-18.29-44.021-41.336-.143-14.487,5.951-25.32,13.619-37.024,8.142-12.428,14.282-26.117,15.346-41.087.915-12.879-.654-26.372,4.7-38.514,5.683-12.881,17.914-21,31.412-23.855,30.113-6.362,55.493,12.963,77.478,30.693,12.292,9.914,24.877,19.457,37.53,28.9,12.891,9.626,26.517,18.661,36.619,31.395,9.613,12.116,15.142,26.907,13.7,42.491-2.664,28.886-22.523,41.407-43.457,50.163",
    transform: "translate(238.792 -23.406)",
    fill: "#ffc477"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolid);
export default __webpack_public_path__ + "static/media/solid.7e38a18b7c050e86b1b10bded1b8e778.svg";
export { ForwardRef as ReactComponent };